export const CHANGE_VIEW_ID: 'VIEW/CHANGE_VIEW_ID' = 'VIEW/CHANGE_VIEW_ID';
export const SAVE_VIEW_ID: 'VIEW/SAVE_VIEW_ID' = 'VIEW/SAVE_VIEW_ID';
export const VIEW_ID_CHANGED: 'VIEW/VIEW_ID_CHANGED' = 'VIEW/VIEW_ID_CHANGED';
export const OPEN_OFF_CANVAS: 'VIEW/OPEN_OFF_CANVAS' = 'VIEW/OPEN_OFF_CANVAS';
export const CLOSE_OFF_CANVAS: 'VIEW/CLOSE_OFF_CANVAS' = 'VIEW/CLOSE_OFF_CANVAS';
export const REQUEST_VIEW: 'VIEW/REQUEST_VIEW' = 'VIEW/REQUEST_VIEW';
export const REQUEST_VIEW_LOADING: 'VIEW/REQUEST_VIEW_LOADING' = 'VIEW/REQUEST_VIEW_LOADING';
export const REQUEST_VIEW_SUCCESS: 'VIEW/REQUEST_VIEW_SUCCESS' = 'VIEW/REQUEST_VIEW_SUCCESS';
export const REQUEST_VIEW_FAILURE: 'VIEW/REQUEST_VIEW_FAILURE' = 'VIEW/REQUEST_VIEW_FAILURE';
export const REQUEST_SAVE_SCROLL_POSITION: 'VIEW/REQUEST_SAVE_SCROLL_POSITION' = 'VIEW/REQUEST_SAVE_SCROLL_POSITION';
export const REQUEST_RESTORE_LAST_SCROLL_POSITION: 'VIEW/REQUEST_RESTORE_LAST_SCROLL_POSITION' =
	'VIEW/REQUEST_RESTORE_LAST_SCROLL_POSITION';
